export const DEMO_ROLE_IDS = new Set([3, 4]);

export function getCurrentStoredUser() {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
}

export function isDemoMode() {
  const user = getCurrentStoredUser();
  return DEMO_ROLE_IDS.has(Number(user?.role_id));
}

export function formatDateFR(dateValue) {
  if (!dateValue) return "—";

  const date = new Date(dateValue);

  if (Number.isNaN(date.getTime())) {
    return String(dateValue);
  }

  return date.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

export function normalizeVisitRows(rows = []) {
  return rows
    .map((row) => {
      const date = row.date_visite;
      const compteur = Number(row.compteur || row.count || 0);

      return {
        ...row,
        date_visite: typeof date === "string" ? date.slice(0, 10) : date,
        date_label: formatDateFR(date),
        compteur,
      };
    })
    .sort((a, b) => {
      return new Date(a.date_visite).getTime() - new Date(b.date_visite).getTime();
    });
}

export function getVisitsStats(rows = [], total = 0) {
  const safeRows = Array.isArray(rows) ? rows : [];

  const todayKey = getLocalDateKey();

  const today = safeRows.find((row) => String(row.date_visite).slice(0, 10) === todayKey);

  const maxDay = safeRows.reduce(
    (best, row) => {
      if (Number(row.compteur || 0) > Number(best.compteur || 0)) return row;
      return best;
    },
    { compteur: 0 }
  );

  const last7Days = safeRows.slice(-7).reduce((sum, row) => {
    return sum + Number(row.compteur || 0);
  }, 0);

  const average =
    safeRows.length > 0
      ? Math.round(total / safeRows.length)
      : 0;

  return {
    total,
    days: safeRows.length,
    today: Number(today?.compteur || 0),
    last7Days,
    average,
    bestDayCount: Number(maxDay?.compteur || 0),
    bestDayLabel: maxDay?.date_visite ? formatDateFR(maxDay.date_visite) : "—",
  };
}

export function getLocalDateKey() {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export function getDefaultDateRange(rows = []) {
  if (!rows.length) {
    const today = getLocalDateKey();

    return {
      dateDebut: today,
      dateFin: today,
    };
  }

  return {
    dateDebut: String(rows[0].date_visite).slice(0, 10),
    dateFin: String(rows[rows.length - 1].date_visite).slice(0, 10),
  };
}